<template>
  <CHeader style="text-align: right" class="mb-4">
    <CFormLabel style="margin-bottom: 3px">{{ $t('events') }}</CFormLabel>
    <CFormSelect
      :md="3"
      v-model="selected_event"
      :options="events_toSelect"
      v-on:change="eventselected($event.target.value)"
    >
    </CFormSelect>
  </CHeader>
</template>

<script>
import Eventservice from '@/services/eventservice'
import i18n from '@/i18n'
const eventservice = new Eventservice()
export default {
  name: 'AppHeader',
  data() {
    return {
      loading: true,
      events: [],
      events_toSelect: [],
      selected_event: null,
    }
  },
  async created() {
    eventservice.getAll().then((response) => {
      this.events = response.data
      this.events_toSelect.push({
        label: i18n.global.t('chooseEvent'),
        value: 'All Events',
        selected: this.isEventSelected(null),
      })
      for (var i = 0; i < this.events.length; i++) {
        this.events_toSelect.push({
          label: this.events[i].name,
          value: JSON.stringify(this.events[i]),
          selected: this.isEventSelected(this.events[i].id),
        })
      }
      this.loading = false
    })
  },
  methods: {
    isEventSelected(eventId) {
      try {
        var localEvent = localStorage.getItem('default_event')
        if (localEvent === 'All Events') {
          return false
        }
        return JSON.parse(localEvent).id === eventId
      } catch (e) {
        return false
      }
    },
    eventselected(event) {
      if (event === 'All Events') {
        localStorage.setItem('default_event', null)
      } else {
        localStorage.setItem('default_event', event)
      }
      window.location.reload()
    },
  },
}
</script>

<style>
#navigation {
  position: absolute; /*or fixed*/
  right: 0px;
  float: right;
}
</style>
